import React, { useState, useEffect } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { Grid, Button } from "@material-ui/core";

import { LoadingSpinner } from "../../../components/common";
import Analytics from "../../../helpers/analytics";

import useWindow from "../../../hooks/useWindow";
import GoToSearch from "./components/GoToSearch";
import GoToRiff from "./components/GoToRiff";
import VideoIsNotAvailable from "../../../images/video is not available.png";

import VideoPlayer from "./components/VideoPlayer";
import VideoDetails from "./components/VideoDetails";
import FloaterDetails from "./components/FloaterDetails";
import Commerce from "./components/Commerce";
import WhatsHotGrid from "../collections/components/PublishedCollections/WhatsHotGrid";
import WhatsHotList from "../collections/components/PublishedCollections/WhatsHotList";
import Recommended from "./components/Recommended";
import Trending from "../home/components/Trending";
import Wrapper from "./components/styles/Wrapper.style";

function Container(props) {
  const {
    user,
    detail,
    auth,
    shopify,
    location,
    publisher,

    addToCart,
    removeFromCart,
    getLatestPublisher,
    onClickShareCollection,
    onClickCollectionCard
  } = props;
  const { video, loading, additionalInfo, recommended } = detail;
  const addFavorite = props.toggleModal;
  const removeFavorite = props.removeVideoFromList;
  const clearAllSearch = props.clearAllSearch;
  const toggleDigitalTermsModal = props.toggleDigitalTermsModal;

  const [showFloater, setShowFloater] = useState(false);
  const { isMobile } = useWindow(991);
  const riffUser = auth.loggedIn && auth.user.roles.includes("ROLE_RIFF_USER") ? true : false;

  const fireGA = (recommended, video) => {
    let videoItem = [];
    recommended.map((items, index) => {
      let obj = {
        item_name: items.publishingTitle,
        item_id: items.jmId,
        item_list_name: "video-detail-recommendations",
        index: index
      };
      return videoItem.push(obj);
    });
    Analytics.track("view_item_list", {
      ecommerce: {
        currency: "USD",
        item_list_name: "Recommended Impression",
        items: [
          {
            item_name: video?.fields?.publishingTitle,
            item_id: video?.fields?.jmId
          },
          ...videoItem
        ]
      }
    });
  };

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (isMobile) {
      setShowFloater(scrollTop > 235);
    }
  };

  useEffect(() => {
    if (!publisher.homepage.latest) {
      getLatestPublisher();
    }
    window.addEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    // props.getVideoDetail(auth.user.access_token, riffUser);
    props.getVideoDeailMVP(auth.user.access_token, riffUser);
    if (window.videoToFavorites && user.loggedIn) {
      props.toggleModal(window.videoToFavorites);
      window.clearNonLoggedInFavorites();
    }
    props.getProducts();
    window.scrollTo({ top: 0 });
  }, [props.location.pathname]);

  useEffect(() => {
    if (detail.recommended !== undefined) {
      fireGA(detail.recommended, detail.video);
    }
  }, [detail]);

  const RenderRecommended = () =>
    recommended && recommended.length > 4 ? (
      <section className="video-detail-bottom">
        <div className="video-detail-container">
          <Recommended
            recommended={recommended}
            user={user}
            auth={auth}
            addFavorite={addFavorite}
            removeFavorite={removeFavorite}
            addToCart={addToCart}
            removeFromCart={removeFromCart}
            isMobile={isMobile}
          />
        </div>
      </section>
    ) : null;

  const RenderPublisher = () => (
    <div className="collection__wrapper">
      <h3 className="collection-header">What's Hot</h3>

      <div className="hot-collections">
        {publisher.fetching ? (
          <LoadingSpinner condition className="loading-symbol loading">
            <div />
          </LoadingSpinner>
        ) : isMobile ? (
          <WhatsHotList
            publisher={publisher}
            onClickShareCollection={onClickShareCollection}
            onClickCollectionCard={onClickCollectionCard}
          />
        ) : (
          <WhatsHotGrid
            publisher={publisher}
            onClickShareCollection={onClickShareCollection}
            onClickCollectionCard={onClickCollectionCard}
          />
        )}
      </div>
    </div>
  );

  return (
    <Wrapper maxWidth="lg">
      {!loading && video ? (
        <div>
          {isMobile && (
            <div className={classnames("video__floater", { showFloater })}>
              <FloaterDetails video={video.fields} />
            </div>
          )}
          <div className="back__riff--toolbar">
            {!isMobile && !video?.fields.error && (
              <GoToSearch clearAllSearch={clearAllSearch} location={location} />
            )}

            {riffUser && !video?.fields.error && <GoToRiff jmId={video.fields.jmId} />}
          </div>

          <Grid container spacing={4} className="root__grid">
            <Grid item xs={12} md={video?.fields.error ? 12 : 8}>
              {video?.fields && !video?.fields?.error ? (
                <VideoPlayer
                  addToCart={addToCart}
                  removeFromCart={removeFromCart}
                  addFavorite={addFavorite}
                  removeFavorite={removeFavorite}
                  clearAllSearch={clearAllSearch}
                  user={user}
                  auth={auth}
                  video={video.fields}
                  additionalInfo={additionalInfo}
                  shopify={shopify}
                  recommended={detail.recommended}
                  location={props.location}
                  history={props.history}
                  sendViewEvent={props.sendViewEvent}
                  isMobile={isMobile}
                />
              ) : (
                <div className="video-player-not-available">
                  <img
                    className="video-player-image"
                    src={VideoIsNotAvailable}
                    alt="video not available"
                  />
                </div>
              )}

              {!isMobile && <RenderPublisher />}
            </Grid>
            <Grid item xs={12} md={video?.fields.error ? 0 : 4}>
              {!isMobile && !video?.fields?.error && (
                <VideoDetails
                  video={video.fields}
                  isMobile={false}
                  auth={auth}
                  additionalInfo={additionalInfo}
                />
              )}
              {!video?.fields?.error && (
                <Commerce
                  addToCart={addToCart}
                  removeFromCart={removeFromCart}
                  user={user}
                  auth={auth}
                  video={video.fields}
                  addFavorite={addFavorite}
                  removeFavorite={removeFavorite}
                  additionalInfo={additionalInfo}
                  toggleDigitalTermsModal={toggleDigitalTermsModal}
                  shopify={shopify}
                  location={props.location}
                  isMobile={isMobile}
                />
              )}
              {!isMobile && <RenderRecommended />}
            </Grid>
          </Grid>

          {isMobile && (
            <Grid container spacing={4} className="root__grid--mobile">
              <Grid item xs={12}>
                <RenderRecommended />
              </Grid>

              <Grid item xs={12}>
                <RenderPublisher />

                <Button variant="outlined" className="search__button">
                  <Link to="/licensing/search">Search Videos</Link>
                </Button>
              </Grid>
            </Grid>
          )}
        </div>
      ) : (
        <LoadingSpinner className="loading-symbol loading loading-detail-page">
          <div />
        </LoadingSpinner>
      )}
    </Wrapper>
  );
}

export default Container;
